<template>
  <div class="container">
    <div
      v-for="profile in current.item.MetadataObject.Profiles"
      :key="profile.ProfileId"
      class="card card-custom gutter-b"
    >
      <div class="card-header border-0 py-5">
        <div class="card-title">
          <span class="h3 card-label font-weight-bolder text-dark">{{
            profile.DisplayName
          }}</span>
          <span class="card-label font-weight-bolder text-dark ml-4"
            >({{ profile.TaxType }})</span
          >
        </div>

        <div class="card-toolbar">
          <button
            v-if="!profile.IsPrimary"
            ref="sethq"
            class="align-self-start btn btn-sm btn-secondary mx-1"
            type="button"
            @click="confirmSetHQ(profile)"
          >
            Set as HQ
          </button>
          <button
            v-if="!profile.IsPrimary"
            ref="delete"
            class="align-self-start btn btn-sm btn-secondary mx-1"
            type="button"
            @click="confirmDelete(profile)"
          >
            Delete
          </button>
          <router-link
            :to="{
              name: 'easyreceipt-profile-edit',
              params: { propdata: profile }
            }"
          >
            <button
              class="align-self-start btn btn-sm btn-primary mx-1"
              type="button" :disabled="!current.allowEdit"
            >
              Edit
            </button>
          </router-link>
        </div>
      </div>
      <div class="card-body pt-0">
        <div class="d-flex">
          <div class="flex-grow-1">
            <div class="d-flex">
              <div class="flex-grow-1 d-flex ">
                <div class="d-flex flex-column flex-root text-dark-75">
                  <span class="font-weight-bolder mb-1">TIN</span>
                  <span class="font-weight-bolder font-size-h5">{{
                    profile.TIN
                  }}</span>
                </div>
                <div class="d-flex flex-column flex-root text-dark-75">
                  <span class="font-weight-bolder mb-1">Branch Code</span>
                  <span class="font-weight-bolder font-size-h5">{{
                    profile.BranchCode
                  }}</span>
                </div>
                <div class="d-flex flex-column flex-root">
                  <span class="font-weight-bolder mb-1">RDO Code</span>
                  <span class="opacity-70">{{ profile.RDO }}</span>
                </div>
                <div class="d-flex flex-column flex-root">
                  &nbsp;<span class="font-weight-bolder mb-1"
                    >Classification</span
                  >
                  <span class="opacity-70">{{ profile.Classification }}</span>
                </div>
              </div>
            </div>
            <div>
              <div class="d-flex justify-content-between pt-4">
                <div class="d-flex flex-column flex-root">
                  <span class="font-weight-bolder mb-1">Business Name</span>
                  <span class="opacity-70">{{ profile.BusinessName }}</span>
                </div>
                <div class="d-flex flex-column flex-root">
                  <span class="font-weight-bolder mb-1">Registered Name</span>
                  <span
                    v-if="profile.Classification !== 'individual'"
                    class="opacity-70"
                    >{{ profile.RegisteredName }}</span
                  >
                  <span
                    v-if="profile.Classification === 'individual'"
                    class="opacity-70"
                    >{{ profile.BusinessFirstName }}
                    {{ profile.BusinessMiddleName }}
                    {{ profile.BusinessLastName }}</span
                  >
                </div>
                <div class="d-flex flex-column flex-root">
                  <span class="font-weight-bolder mb-1">Business Address</span>
                  <span class="opacity-70">{{ profile.BusinessAddress }}</span>
                </div>
              </div>
              <div class="d-flex justify-content-between pt-4">
                <div class="d-flex flex-column flex-root">
                  <span class="font-weight-bolder mb-1">Mobile Number</span>
                  <span class="opacity-70">{{
                    profile.AuthorizedUser.MobileNumber
                  }}</span>
                </div>
                <div class="d-flex flex-column flex-root">
                  <span class="font-weight-bolder mb-1">Landline</span>
                  <span class="opacity-70">{{
                    profile.AuthorizedUser.Landline
                  }}</span>
                </div>
                <div class="d-flex flex-column flex-root">
                  <span class="font-weight-bolder mb-1">Email Address</span>
                  <span class="opacity-70">{{
                    profile.AuthorizedUser.EmailAddress
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-link :to="{ name: 'easyreceipt-profile-create', params: {} }">
      <button
        class="align-self-start btn btn-sm btn-primary mx-1"
        type="button"
      >
        Add another
      </button>
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ApiService from "@/view/pages/easyreceipt/api";
import Vue from "vue";
import Swal from "sweetalert2";
import moment from "moment";

Vue.use(require("vue-moment"));
export default {
  components: {},
  props: {
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isBusy: false,
      tabIndex: 0,
      current: {
        item: {
          MetadataObject: { Profiles: [] }
        },
        allowEdit: false
      }
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.setBreadcrumbs("My Business Information");
      this.getData(this.id)
        .then(() => {
          //this.setBreadcrumbs(data.PropertyIdentifier);
        })
        .catch();
    },
    setBreadcrumbs(value) {
      let payload = [
      ];
      payload.push({ title: value });
      this.$store.dispatch(SET_BREADCRUMB, payload);
    },
    getData() {
      this.isBusy = true;
      let self = this;
      return new Promise((resolve, reject) => {
        let param = {};
        ApiService.get("business/me", param)
          .then(({ data }) => {
            this.$gtag.event("business_me", param);
            self.current.item = data;
            let allowedDaysToEdit = 14;
            let maxEditDate = moment(self.current.item.CreatedDateTime).add(allowedDaysToEdit, 'd');
            this.current.allowEdit = moment().isBefore(maxEditDate);
            self.isBusy = false;
            resolve(data);
          })
          .catch(({ response }) => {
            reject(response);
          });
      });
    },
    confirmSetHQ(item) {
      Swal.fire({
        //title: 'Are you sure?',
        html:
          "Are you sure you want set <br/> <span class='h3'>" +
          item.DisplayName +
          "</span> as HQ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then(result => {
        if (result.isConfirmed) {
          this.submitSetHQ(item);
        }
      });
    },
    submitSetHQ(item) {
      let self = this;
      self.isBusy = true;
      let param = {
        ProfileId: item.ProfileId
      };
      const btn = self.$refs["sethq"][0];
      btn.classList.add("spinner", "spinner-light", "spinner-right");
      ApiService.post("business/setprimary", param)
        .then(data => {
          this.$gtag.event("business_setprimary", param);
          if (data) {
            self.isBusy = false;
            btn.classList.remove("spinner", "spinner-light", "spinner-right");
            this.getData();
          }
        })
        .catch(() => {
          self.isBusy = false;
          btn.classList.remove("spinner", "spinner-light", "spinner-right");
        });
    },
    confirmDelete(item) {
      Swal.fire({
        //title: 'Are you sure?',
        html:
          "Are you sure you want delete <br/> <span class='h3'>" +
          item.DisplayName +
          "</span>?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then(result => {
        if (result.isConfirmed) {
          this.submitDelete(item);
        }
      });
    },
    submitDelete(item) {
      let self = this;
      self.isBusy = true;
      let param = {
        ProfileId: item.ProfileId
      };
      const btn = self.$refs["delete"][0];
      btn.classList.add("spinner", "spinner-light", "spinner-right");
      ApiService.post("business/delete", param)
        .then(data => {
          this.$gtag.event("business_delete", param);
          if (data) {
            self.isBusy = false;
            btn.classList.remove("spinner", "spinner-light", "spinner-right");
            this.getData();
          }
        })
        .catch(() => {
          self.isBusy = false;
          btn.classList.remove("spinner", "spinner-light", "spinner-right");
        });
    }
  },
  watch: {}
};
</script>
